import { css } from 'styled-components';

const typographyCss = css`
  /* text align */
  .has-text-centered {
    text-align: center;
  }
  
  /* text weight */
  .has-text-weight-normal {
    font-weight: var(--font-weights-normal);
  }
  
  .has-text-weight-medium {
    font-weight: var(--font-weights-medium);
  }
  
  .hsa-text-weight-semibold {
    font-weight: var(--font-weights-semibold);
  }
  
  .has-text-weight-bold {
    font-weight: var(--font-weights-bold);
  }
  
  /* text transform */
  .is-capitalized {
    text-transform: capitalize;
  }
  
  .is-uppercase {
    text-transform: uppercase;
  }
  
  .is-lowercase {
    text-transform: lowercase;
  }
`;

export default typographyCss;
